import { render, staticRenderFns } from "./HoverSection.vue?vue&type=template&id=137666f4&scoped=true&"
import script from "./HoverSection.vue?vue&type=script&lang=js&"
export * from "./HoverSection.vue?vue&type=script&lang=js&"
import style0 from "./HoverSection.vue?vue&type=style&index=0&id=137666f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137666f4",
  null
  
)

export default component.exports